import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { AccessibleItem } from "src/common/userMainWindow/userMainWindow-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { ServerSideDataLoader, PaginationInfo, FileSelectorViewModel } from "uicomponents";
import { ProductSearchableSelectorViewModel } from "../productSearch/productSearchableSelector/productSearchableSelector-viewModel";
import { CurrentDistrictWarehousesSelectorViewModel } from "../warehouseManipulation/warehouseManipulation-viewModel";
import { BalanceTuningRequestView } from "./balanceTuningRequest-view";

export class BalanceTuningRequestViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'تنظیم بهینه انبار';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.lineItems = ObservableArray.create<lineItem>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation));
        this.refresh();
        this.fileSelector = new FileSelectorViewModel(this);
    }
    GetDefaultView(): View <ViewModel> {
        return new BalanceTuningRequestView();
    }
    public getTypeId(): string {
        return "VM-86F3A575-E9E0-45D3-8FAF-4A5CBB7DA98C"
    }
    
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set lineItems(v: ObservableArray<lineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<lineItem> { return this._lineItems;} private _lineItems: ObservableArray<lineItem>;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;

    
    async refresh(){
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            if(filteringInformation.OrderInfo.length == 0)
            {
                let sort = {
                    fieldName:'createdTime',
                    order:'DESC',
                    type:'date'
                };
                filteringInformation.OrderInfo = [sort];
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/BalanceTuningRequestList',{
                FilteringInformation:filteringInformation,
            });
            this.lineItems.update(...result.BalanceTuningRequest.map((q,i)=>{
                let r = new lineItem(this);
                r.rowNumber = i+1;
                r.BalanceTuningRequestId = q.BalanceTuningRequestId;
                r.creationTime = moment.utc(q.CreatedDate);
                r.measuredProductId = q.MeasuredProductId;
                r.productName = q.ProductName;
                r.productCode = q.ProductCode;
                r.productCarModel = q.ProductCarModel;
                r.fromWarehouseName = q.FromWarehouseName;
                r.toWarehouseName = q.ToWarehouseName;
                r.stockBalance = q.StockBalance;
                r.availableBalance = q.AccessibleBalance;
                r.newBalance = q.Balance;
                r.sellProcessBalance = q.SellProcessBalance;
                r.isEdited = false;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async save(item:lineItem){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/WarehouseServices/UpdateBalanceTuningRequest',{
                BalanceTuningRequestId:item.BalanceTuningRequestId,
                Balance:item.newBalance,
            });
        } catch (ex) {
            throw ex;
        } finally {
            this.isLoading = false;
        }
    }
    async createRequest(){
        let editor = new balanceTuningRequestEditor(this);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }

    async createRequestsBatch(){
        let popupResult = await this.showPopup(new BatchBalanceTuning(this));
        if(popupResult==true){
            this.refresh();
        }
    }   

    async import(){
        let errors :string[]= [];
        if(!this.fileSelector?.isFileChoosed()){
            errors.push('فایلی انتخاب نشده است.');
        }
        let validationResult = errors.join("\n");
        if(validationResult != ""){
            await this.messageBoxConfirmWarning(validationResult,"خطا");
            return ;
        }
            
        let popupResult = await this.showPopup(new ImportBalanceTuning(this, this.fileSelector.filecontent));
        if(popupResult==true){
            this.refresh();
        }
    }   

    async returnLowSales(){
        let popupResult = await this.showPopup(new ReturnLowSales(this));
        if(popupResult==true){
            this.refresh();
        }
    }   
}

export class lineItem extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:BalanceTuningRequestViewModel) {
        super(parent);
        this.typedParent = parent;
    }
    private typedParent : BalanceTuningRequestViewModel;

    public set BalanceTuningRequestId(v: string) { this._BalanceTuningRequestId = v; } public get BalanceTuningRequestId(): string { return this._BalanceTuningRequestId;} private _BalanceTuningRequestId: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime;} private _creationTime: moment.Moment;
    public set fromWarehouseName(v: string) { this._fromWarehouseName = v; } public get fromWarehouseName(): string { return this._fromWarehouseName;} private _fromWarehouseName: string;
    public set toWarehouseName(v: string) { this._toWarehouseName = v; } public get toWarehouseName(): string { return this._toWarehouseName;} private _toWarehouseName: string;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId;} private _measuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set productBrand(v: string) { this._productBrand = v; } public get productBrand(): string { return this._productBrand;} private _productBrand: string;
    public set stockBalance(v: number) { this._stockBalance = v; } public get stockBalance(): number { return this._stockBalance;} private _stockBalance: number;
    public set availableBalance(v: number) { this._availableBalance = v; } public get availableBalance(): number { return this._availableBalance;} private _availableBalance: number;
    public set newBalance(v: number) { 
        this._newBalance = getAsNumber(v,true); 
        this.isEdited = true;
    } public get newBalance(): number { return this._newBalance;} private _newBalance: number;
    public set sellProcessBalance(v: number) { this._sellProcessBalance = v; } public get sellProcessBalance(): number { return this._sellProcessBalance;} private _sellProcessBalance: number;
    public set isEdited(v: boolean) { this._isEdited = v; } public get isEdited(): boolean { return this._isEdited;} private _isEdited: boolean;
    
    async confirm(){
        let confirmation ='';
        confirmation = await this.messageBoxWarningYesNo('آیا تعداد درخواستی بروزرسانی شود؟','بروزرسانی تعداد درخواستی');
        if(confirmation=='no'){
            return;
        }
        try {
            this.typedParent.isLoading = true;
            if(this.newBalance === 0){
                await this.messageBoxConfirmWarning('تعداد نمی تواند صفر باشد.','عدم امکان بروزرسانی تعداد');
                throw "new Error";
            }
            if(this.newBalance > this.availableBalance){
                await this.messageBoxConfirmWarning('تعداد از موجود در دسترس بیشتر شده است.','عدم امکان بروزرسانی تعداد');
                throw "new Error";
            }
            await this.typedParent.save(this);
            this.isEdited = false;
            await this.messageBoxConfirmSuccess('تعداد درخواستی با موفقیت بروزرسانی شد.' ,'بروزرسانی تعداد درخواستی');
        } catch (ex) {
            console.log(ex);
        } finally {
            this.typedParent.isLoading = false;
        }
    }

}

export class ProductRow extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:balanceTuningRequestEditor) {
        super(parent);
        this.typedParent = parent;
        this.newBalance = 0;
    }
    private typedParent : balanceTuningRequestEditor;

    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set fromWarehouseId(v: string) { this._fromWarehouseId = v; } public get fromWarehouseId(): string { return this._fromWarehouseId;} private _fromWarehouseId: string;
    public set fromWarehouseName(v: string) { this._fromWarehouseName = v; } public get fromWarehouseName(): string { return this._fromWarehouseName;} private _fromWarehouseName: string;
    public set toWarehouseId(v: string) { this._toWarehouseId = v; } public get toWarehouseId(): string { return this._toWarehouseId;} private _toWarehouseId: string;
    public set toWarehouseName(v: string) { this._toWarehouseName = v; } public get toWarehouseName(): string { return this._toWarehouseName;} private _toWarehouseName: string;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId;} private _measuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set productBrand(v: string) { this._productBrand = v; } public get productBrand(): string { return this._productBrand;} private _productBrand: string;
    public set stockBalance(v: number) { this._stockBalance = v; } public get stockBalance(): number { return this._stockBalance;} private _stockBalance: number;
    public set availableBalance(v: number) { this._availableBalance = v; } public get availableBalance(): number { return this._availableBalance;} private _availableBalance: number;
    public set nosaleLockAmount(v: number) { this._nosaleLockAmount = v; } public get nosaleLockAmount(): number { return this._nosaleLockAmount;} private _nosaleLockAmount: number;
    public set allowedBalance(v: number) { this._allowedBalance = v; } public get allowedBalance(): number { return this._allowedBalance;} private _allowedBalance: number;
    
    public set destinaionBalance(v: number) { this._destinaionBalance = v; } public get destinaionBalance(): number { return this._destinaionBalance;} private _destinaionBalance: number;
    public set destinaionAvailableBalance(v: number) { this._destinaionAvailableBalance = v; } public get destinaionAvailableBalance(): number { return this._destinaionAvailableBalance;} private _destinaionAvailableBalance: number;
    public set newBalance(v: number) { 
        this._newBalance = getAsNumber(v,true); 
    } public get newBalance(): number { return this._newBalance;} private _newBalance: number;
    
    async remove(){
        this.typedParent.remove(this);
        
    }

}

export class balanceTuningRequestEditor extends ViewModel implements IPopup{
    public getTypeId(): string {return 'singlerequest';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:BalanceTuningRequestViewModel) {
        super(parent);
        this.products = ObservableArray.create<ProductRow>();
        this.fromWarehouseSelector = new CurrentDistrictWarehousesSelectorViewModel(this, true, false, true, true, false);
        this.toWarehouseSelector = new CurrentDistrictWarehousesSelectorViewModel(this, false, false, true, true, false);
        this.productSelector = new ProductSearchableSelectorViewModel(this,true);
        this.fromWarehouseSelector.onSelectionChanged = q=>{
            this.getWarehouseBalanceInfo();
        }
        this.toWarehouseSelector.onSelectionChanged = q=>{
            this.getDestinationWarehouseBalanceInfo();
        }
        this.productSelector.onSelectionChanged = q=>{
            if(this.products.findIndex(o => o.measuredProductId === q.measuredProducts[0].id) === -1){
                let newProduct = new ProductRow(this);
                newProduct.rowNumber = this.products.length + 1; 
                newProduct.measuredProductId = q.measuredProducts[0].id;
                newProduct.productCarModel = q.productCarModel;
                newProduct.productCode = q.code;
                newProduct.productName = q.productName;
                newProduct.productBrand = q.productBrand;
                this.products.push(newProduct);
                this.getWarehouseBalanceInfo();
                this.getDestinationWarehouseBalanceInfo();
            };
        }
        
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set products(v: ObservableArray<ProductRow>) { this._products = v; } public get products(): ObservableArray<ProductRow> { return this._products;} private _products: ObservableArray<ProductRow>;
    public set productSelector(v: ProductSearchableSelectorViewModel) { this._productSelector = v; } public get productSelector(): ProductSearchableSelectorViewModel { return this._productSelector;} private _productSelector: ProductSearchableSelectorViewModel;
    public set fromWarehouseSelector(v: CurrentDistrictWarehousesSelectorViewModel) { this._fromWarehouseSelector = v; } public get fromWarehouseSelector(): CurrentDistrictWarehousesSelectorViewModel { return this._fromWarehouseSelector;} private _fromWarehouseSelector: CurrentDistrictWarehousesSelectorViewModel;
    public set toWarehouseSelector(v: CurrentDistrictWarehousesSelectorViewModel) { this._toWarehouseSelector = v; } public get toWarehouseSelector(): CurrentDistrictWarehousesSelectorViewModel { return this._toWarehouseSelector;} private _toWarehouseSelector: CurrentDistrictWarehousesSelectorViewModel;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.getFromWarehouseId())){
            result.push('انبار مبدا مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.getToWarehouseId())){
            result.push('انبار مقصد مشخص نشده است.')
        } 
        if(this.getToWarehouseId() === this.getFromWarehouseId()){
            result.push('انبار مبدا و مقصد نباید یکسان باشد.')
        } 
        if(this.products.length < 1){
            result.push(' کالایی اضافه نشده است.')
        }
        if(!this.products.every(x=> {
            return x.newBalance !== 0;
        })){
            result.push(' تعداد نمی تواند صفر باشد.')
        }
        if(!this.products.every(x=> {
            return x.newBalance <= x.allowedBalance;
        })){
            result.push(' تعداد از موجود در دسترس بیشتر شده است.')
        }
        
        return result;
    }

    remove (removedProduct: ProductRow) {
        let index = this.products.findIndex(o => o.measuredProductId === removedProduct.measuredProductId);
        this.products.splice(index,1);
        for (let i = index; i < this.products.length; i++) {
            let element = this.products[i];
            element.rowNumber--;
        }
    }
    
    async getWarehouseBalanceInfo() {
        if(stringIsNullOrEmpty(this.getFromWarehouseId())){
            await this.messageBoxConfirmWarning('انبار مبدا مشخص نشده است.','عدم امکان ثبت درخواست');
            throw "new Error";
        }
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetWarehouseBalanceByProductIds',{
                MeasuredProductIds: this.products.map(q => {
                    return {
                        WarehouseId: this.getFromWarehouseId(),
                        MeasuredProductId : q.measuredProductId
                    }
                })
            });
            if(result.IsSuccessful==false){
                throw "new Error";
            }
            result.WarehouseBalances.map(p => {
                let f = this.products.find(x => x.measuredProductId === p.MeasuredProductId);
                f.stockBalance = p.StockBalance;
                f.availableBalance = p.AccessibleBalance;
                f.nosaleLockAmount = p.NoSaleLockAmount;
                f.allowedBalance = f.availableBalance + f.nosaleLockAmount;
            });
    }
    
    async getDestinationWarehouseBalanceInfo() {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetWarehouseBalanceByProductIds',{
                MeasuredProductIds: this.products.map(q => {
                    return {
                        WarehouseId: this.getToWarehouseId(),
                        MeasuredProductId : q.measuredProductId
                    }
                })
            });
            if(result.IsSuccessful==false){
                throw "new Error";
            }
            result.WarehouseBalances.map(p => {
                let f = this.products.find(x => x.measuredProductId === p.MeasuredProductId);
                f.destinaionBalance = p.StockBalance;
                f.destinaionAvailableBalance = p.AccessibleBalance;
            });
    }
    
    closePopup(resultCode: string = null) {
    }
    
    setFormWarehouse(id: string) {
        this.fromWarehouseSelector.selectById(id);
    }

    getFromWarehouseId() {
        return this.fromWarehouseSelector.selectedItem?.id;
    }  

    setToWarehouse(id: string) {
        this.toWarehouseSelector.selectById(id);
    }

    getToWarehouseId() {
        return this.toWarehouseSelector.selectedItem?.id;
    }
    
    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت درخواست');
                return;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/CreateBalanceTuningRequest',{
                Products:this.products.map(q => {
                    return {
                        MeasuredProductId: q.measuredProductId,
                        Balance: q.newBalance
                    }
                }),
                FromWarehouseId:this.getFromWarehouseId(),
                ToWarehouseId:this.getToWarehouseId()
            });
            if(result.IsSuccessful==false){
                throw "new Error";
            }
            if (result.Duplicated == true) {
                throw `درخواست بهینه قبلا ثبت شده است.`;
            }
            let message :string[] =[];
            result.Products.map(q => {
                if (q.Created) {
                    message.push(`تنظیم بهینه انبار برای کالای ${q.ProductCode} با موفقیت ثبت شد.`)
                } else {
                    message.push(`درخواست بهینه برای کالای ${q.ProductCode} قبلا ثبت شده است.`)
                }
            })
            await this.messageBoxConfirmSuccess(message.join('\n'),'عملیات موفق');
            this.closePopup("done");
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex,'خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }
}


export class BatchBalanceTuning extends ViewModel implements IPopup{
    public getTypeId(): string {return 'batchrequest';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.items = ObservableArray.create<SingleBalanceTuningRequest>();
        this.refresh()
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<SingleBalanceTuningRequest>) { this._items = v; } public get items(): ObservableArray<SingleBalanceTuningRequest> { return this._items;} private _items: ObservableArray<SingleBalanceTuningRequest>;
    public set isMakeAutomaticBalanceRequest(v: boolean) { this._isMakeAutomaticBalanceRequest = v; } public get isMakeAutomaticBalanceRequest(): boolean { return this._isMakeAutomaticBalanceRequest;} private _isMakeAutomaticBalanceRequest: boolean;
    

    async refresh(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetBalanceTuningAutomaticReport',{});
            this.items.update(...result.Report.map((x,i)=>{
                let r = new SingleBalanceTuningRequest(this);
                r.index = i+1;
                r.productId = x.ProductId;
                r.measuredProductId = x.MeasuredProductId;
                r.productName = x.Name;
                r.productCode = x.Code;
                r.brand = x.Brand;
                r.carModel = x.CarModel;
                r.destinationBalance = x.DestinationBalance;
                r.sourceBalance = x.SourceBalance;
                r.requestAmount = x.RequestAmount;
                r.isDuplicated = x.IsDuplicated;
                return r;
            }));
            let result2 = await ServerConnection.callServer('/Complex/WarehouseServices/GetAutomaticBalanceRequest',{});
            this.isMakeAutomaticBalanceRequest = result2.IsMakeAutomaticBalanceRequest;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    closePopup(result?: any) {
    }
    
    async confirm(){
        if(this.items.filter(x=>x.isValid==false).length>0){
            this.messageBoxConfirmWarning('مقدار درخواستی در تمامی سطرها دارای مقدار صحیح نیست.','عدم امکان ثبت');
            return;
        }
        let toSaveAmounts = this.items.filter(x=>x.requestAmount>0);
        if(toSaveAmounts.length==0){
            this.messageBoxConfirmWarning('هیچ یک از سطرها دارای مقدار بیش از صفر جهت ثبت بهینه نیستند.','عدم امکان ثبت');
            return;
        }
        toSaveAmounts = toSaveAmounts.filter(x=>x.isDuplicated==false);
        if(toSaveAmounts.length == 0){
            this.messageBoxConfirmWarning(' تمامی سطرها قبلا ثبت شده است.','عدم امکان ثبت');
            return;
        }
        let confirmationResult = await this.messageBoxWarningYesNo('آیا عملیات ثبت بهینه ثبت شود؟','ثبت بهینه');
        if(confirmationResult=='yes'){
            try {
                this.isLoading = true;
                let result =await ServerConnection.callServer('/Complex/WarehouseServices/CreateBalanceTuningRequestBatch',{
                    Items : toSaveAmounts.map(x=>{
                        return {
                            MeasuredProductId : x.measuredProductId,
                            Amount : x.requestAmount
                        };
                    })
                })
                if(result.IsSuccessful){
                    await this.messageBoxConfirmSuccess("ثبت بهینه با موفقیت انجام شد",'ثبت موفق');
                    this.closePopup(true);
                }else{
                    this.messageBoxConfirmWarning('خطا در ثبت بهینه انبار','خطا در انجام عملیات')
                }
            } catch (ex) {
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
    
    async toggleMakeAutomaticBalanceRequest(){
        try {
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/WarehouseServices/ToggleAutomaticBalanceRequest',{
            })
            if(result.IsSuccessful){
                await this.messageBoxConfirmSuccess("تنظیم خودکار بهینه انبار تغییر کرد.",'ثبت موفق');
            }else{
                this.messageBoxConfirmWarning('خطا در ثبت بهینه انبار','خطا در انجام عملیات')
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup(null);
    }
}

export class ImportBalanceTuning extends ViewModel implements IPopup{
    public getTypeId(): string {return 'importRequest';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel, fileContent: string) {
        super(parent);
        this.items = ObservableArray.create<SingleBalanceTuningRequest>();
        this.refresh(fileContent)
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<SingleBalanceTuningRequest>) { this._items = v; } public get items(): ObservableArray<SingleBalanceTuningRequest> { return this._items;} private _items: ObservableArray<SingleBalanceTuningRequest>;
    

    async refresh(fileContent: string){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetBalanceTuningFromExcel',{
                ExcelFile : fileContent
            });
            let mapObj = new Map();
            result.Products.forEach(v => {
                let prevValue = mapObj.get(v.Code)
                if(!prevValue || prevValue.type === "new"){
                mapObj.set(v.Code, v)
                } 
            })
            let items = [...mapObj.values()];
            
            this.items.update(...items.map((x,i)=>{
                let r = new SingleBalanceTuningRequest(this);
                r.index = i+1;
                r.measuredProductId = x.MeasuredProductId;
                r.productName = x.Name;
                r.productCode = x.Code;
                r.brand = x.Brand;
                r.carModel = x.CarModel;
                r.requestAmount = x.RequestAmount;
                r.isValid = r.requestAmount > 0;
                r.destinationBalance = x.DestinationBalance;
                r.sourceBalance = x.SourceBalance;
                r.isDuplicated = x.IsDuplicated;
                return r;
            }));
            
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    closePopup(result?: any) {
    }
    
    async confirm(){
        
        let toSaveAmounts = this.items.filter(x=>x.isValid);
        if(toSaveAmounts.length==0){
            this.messageBoxConfirmWarning('هیچ یک از سطرها دارای مقدار بیش از صفر جهت ثبت بهینه نیستند.','عدم امکان ثبت');
            return;
        }
        toSaveAmounts = toSaveAmounts.filter(x=>x.isDuplicated==false);
        if(toSaveAmounts.length == 0){
            this.messageBoxConfirmWarning(' تمامی سطرها قبلا ثبت شده است.','عدم امکان ثبت');
            return;
        }
        let confirmationResult = await this.messageBoxWarningYesNo('آیا عملیات ثبت بهینه ثبت شود؟','ثبت بهینه');
        if(confirmationResult=='yes'){
            try {
                this.isLoading = true;
                let result =await ServerConnection.callServer('/Complex/WarehouseServices/CreateBalanceTuningRequestBatch',{
                    Items : toSaveAmounts.map(x=>{
                        return {
                            MeasuredProductId : x.measuredProductId,
                            Amount : x.requestAmount
                        };
                    })
                })
                if(result.IsSuccessful){
                    await this.messageBoxConfirmSuccess("ثبت بهینه با موفقیت انجام شد",'ثبت موفق');
                    this.closePopup(true);
                }else{
                    this.messageBoxConfirmWarning('خطا در ثبت بهینه انبار','خطا در انجام عملیات')
                }
            } catch (ex) {
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
    
    back(){
        this.closePopup(null);
    }
}

export class ReturnLowSales extends ViewModel implements IPopup{
    public getTypeId(): string {return 'returnSale';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.items = ObservableArray.create<SingleBalanceTuningRequest>();
        this.refresh()
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<SingleBalanceTuningRequest>) { this._items = v; } public get items(): ObservableArray<SingleBalanceTuningRequest> { return this._items;} private _items: ObservableArray<SingleBalanceTuningRequest>;
    

    async refresh(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetReturnLowSalesRequest',{});
            this.items.update(...result.Report.map((x,i)=>{
                let r = new SingleBalanceTuningRequest(this);
                r.index = i+1;
                r.productId = x.ProductId;
                r.measuredProductId = x.MeasuredProductId;
                r.productName = x.Name;
                r.productCode = x.Code;
                r.brand = x.Brand;
                r.carModel = x.CarModel;
                r.sourceBalance = x.SourceBalance;
                r.requestAmount = x.RequestAmount;
                r.isDuplicated = x.IsDuplicated;
                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    closePopup(result?: any) {
    }
    
    async confirm(){
        if(this.items.filter(x=>x.isValid==false).length>0){
            this.messageBoxConfirmWarning('مقدار درخواستی در تمامی سطرها دارای مقدار صحیح نیست.','عدم امکان ثبت');
            return;
        }
        let toSaveAmounts = this.items.filter(x=>x.requestAmount>0);
        if(toSaveAmounts.length==0){
            this.messageBoxConfirmWarning('هیچ یک از سطرها دارای مقدار بیش از صفر جهت ثبت بهینه نیستند.','عدم امکان ثبت');
            return;
        }
        toSaveAmounts = toSaveAmounts.filter(x=>x.isDuplicated==false);
        if(toSaveAmounts.length == 0){
            this.messageBoxConfirmWarning(' تمامی سطرها قبلا ثبت شده است.','عدم امکان ثبت');
            return;
        }
        let confirmationResult = await this.messageBoxWarningYesNo('آیا عملیات ثبت بهینه ثبت شود؟','ثبت بهینه');
        if(confirmationResult=='yes'){
            try {
                this.isLoading = true;
                let result =await ServerConnection.callServer('/Complex/WarehouseServices/CreateBalanceTuningReturnLowSale',{
                    Items : toSaveAmounts.map(x=>{
                        return {
                            MeasuredProductId : x.measuredProductId,
                            Amount : x.requestAmount
                        };
                    })
                })
                if(result.IsSuccessful){
                    await this.messageBoxConfirmSuccess("ثبت بهینه با موفقیت انجام شد",'ثبت موفق');
                    this.closePopup(true);
                }else{
                    this.messageBoxConfirmWarning('خطا در ثبت بهینه انبار','خطا در انجام عملیات')
                }
            } catch (ex) {
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
    back(){
        this.closePopup(null);
    }
}

export class SingleBalanceTuningRequest extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId;} private _productId: string;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId;} private _measuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set brand(v: string) { this._brand = v; } public get brand(): string { return this._brand;} private _brand: string;
    public set carModel(v: string) { this._carModel = v; } public get carModel(): string { return this._carModel;} private _carModel: string;
    public set destinationBalance(v: number) { this._destinationBalance = getAsNumber(v); } public get destinationBalance(): number { return this._destinationBalance;} private _destinationBalance: number;
    public set sourceBalance(v: number) { this._sourceBalance = getAsNumber(v);this.validate(); } public get sourceBalance(): number { return this._sourceBalance;} private _sourceBalance: number;
    public set requestAmount(v: number) { this._requestAmount = getAsNumber(v);this.validate(); } public get requestAmount(): number { return this._requestAmount;} private _requestAmount: number;
    public set isDuplicated(v: boolean) { this._isDuplicated = v; } public get isDuplicated(): boolean { return this._isDuplicated;} private _isDuplicated: boolean;
    public set isValid(v: boolean) { this._isValid = v; } public get isValid(): boolean { return this._isValid;} private _isValid: boolean;
        
    validate(){
        if(this.requestAmount<=0)
            this.isValid = false;
        else if(this.requestAmount>this.sourceBalance)
            this.isValid = false;
        else this.isValid = true;
    }
}